import storageManager from '@/storage-manager';

export default {
  /**
   * Saves an item to Vuex store and other storage methods.
   *
   * @param {*} state
   * @param {*} payload
   */
  addItem(state, payload) {
    // const data = SessionStore.cleanupItems(payload);
    const savedItem = payload.savedJobItems || payload.savedReviewItems || payload.savedCompanyItems;
    state.data.savedItems.unshift(savedItem);
    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  /**
   * Removes an item from the Vuex store and other storage methods.
   *
   * @param {*} state
   * @param {*} payload
   */
  removeItem(state, payload) {
    state.data.savedItems = state.data.savedItems.filter((n) => {
      if (+n.id === +payload.deletedItem.id && n.type === payload.deletedItem.type) {
        return false;
      }
      return true;
    });

    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  updateItem(state, payload = {}) {
    const indexToUpdate = state.data.savedItems.findIndex((item) => {
      return item.id === +payload.id && item.type === payload.type;
    });

    if (indexToUpdate !== -1) {
      console.log('replace', indexToUpdate, state.data[indexToUpdate]);
      state.data.savedItems.splice(indexToUpdate, 1, payload);
    } else {
      console.log('add');
      // TODO: this add scenario is triggered by the opt in modal.
      state.data.savedItems.unshift(payload);
    }

    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  replaceItemsByType(state, { items = [], type }) {
    const itemsNotOfCurrentType = state.data.savedItems.filter((item) => {
      return item.type !== type;
    });
    state.data.savedItems = [
      ...itemsNotOfCurrentType,
      ...items,
    ];

    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  // TODO this needs to change
  // only here because of the backend.
  replaceOptInItem(state, { newItem, oldItem }) {
    const indexToUpdate = state.data.savedItems.findIndex((item) => {
      return item.id === +oldItem.id && item.type === oldItem.type;
    });

    if (indexToUpdate !== -1) {
      console.log('replace', indexToUpdate, state.data.savedItems[indexToUpdate]);
      state.data.savedItems.splice(indexToUpdate, 1);
      state.data.savedItems.push(newItem);
    }

    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  /**
   * Set all the saved items in the store,
   *
   * Scenario 1 - page load, pulled from localStorage
   * Scenario 2 - via ajax on page load, if localStorage empty
   * Scenario 3 - via ajax after login via ajax
   *
   * @param {*} state
   * @param {*} payload
   */
  setItemData(state, payload) {
    const {
      savedItems,
    } = payload;

    state.data = { savedItems };
    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  /**
   * Resets state data
   *
   * Scenario 1 - user logs out, kill sessionStorage before redirect
   * Scenario 2 - users performs an action but is no longer logged in
   *
   * @param {*} state
   */
  resetData(state) {
    state.data = { savedItems: [] };
    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },

  /**
   * Sets all reminder fields to 0
   *
   * Scenario 1 - User clicks unsubscribe all on /dashboard/contact-preferences/
   *
   * @param {*} state
   */
  unsubscribeFromAllReminders(state) {
    state.data.savedItems.filter((item) => {
      return item.type === 'jobs' || item.type === 'companies';
    }).forEach((item) => {
      if (item.reminders && item.reminders === 1) {
        item.reminders = 0;
      }
    });

    storageManager.setSessionStorage({ key: 'saved-items|items', items: state.data });
  },
};
